<div
  [ngClass]="
    'widget__item clickable ' +
    (classList | addClassList: { mainClass: 'widget__item--' }) +
    (city ? ' widget__item--has-content' : '')
  "
>
  <span
    id="qa_open-cities-list"
    [ngClass]="
      'widget__element-label location-label ' +
      (city && city.city ? ' widget__element-label--notEmpty' : '') +
      (showCityPicker && isHeaderSearch ? ' widget__element-label--header-opened' : '') +
      (classList | addClassList: { mainClass: 'widget__element-label--' })
    "
    (click)="showHideCityPicker()"
  >
    {{ labelText | translate }}
  </span>
  <div
    class="widget__item-picker-wrap {{ classList | addClassList: { mainClass: 'widget__item-picker-wrap--' } }}"
    (click)="showHideCityPicker()"
  >
    <div class="widget__select">
      <div class="widget__select-list">
        <div
          id="qa_city-picker-name"
          [ngClass]="
            'widget__single-line widget__single-line--city ' +
            (classList | addClassList: { mainClass: 'widget__single-line--' })
          "
        >
          <ng-container *ngIf="!showCityPicker">{{ city ? (city.city | localize) : '' }}</ng-container>
          <div class="widget__element-icon {{ classList | addClassList: { mainClass: 'widget__element-icon--' } }}">
            <ng-container *ngTemplateOutlet="limehomeMagnifierSvg" />
          </div>
        </div>
      </div>
      <div
        *ngIf="showCityPicker"
        class="widget__select-options {{ classList | addClassList: { mainClass: 'widget__select-options--' } }}"
        [appDropDownPosition]="{ tabletPortraitMaxHeight: 536, tabletLandscapeMaxHeight: 355, desktopMaxHeight: 391 }"
      >
        <div
          [ngClass]="'widget__cities-search ' + (classList | addClassList: { mainClass: 'widget__cities-search--' })"
          (click)="$event.stopPropagation()"
        >
          <form
            class="form__search widget__cities-search-form {{
              classList | addClassList: { mainClass: 'widget__cities-search-form--' }
            }}"
          >
            <input
              #searchField
              type="text"
              name="search"
              id="search"
              autocomplete="off"
              class="form__search__input widget__cities-search-input {{
                classList | addClassList: { mainClass: 'widget__cities-search-input--' }
              }}"
              [placeholder]="searchPlaceholderText | translate"
              [(ngModel)]="searchModel"
              (keyup)="searchCities()"
              (keydown.arrowdown)="onArrowDown($event)"
              (keydown.arrowup)="onArrowUp($event)"
              (keyup.enter)="onEnterKey($event)"
              (keyup.esc)="onEscKey($event)"
            />

            <div
              *ngIf="!isMobile && !searchModel"
              class="widget__element-icon widget__element-icon--dropdown {{
                classList | addClassList: { mainClass: 'widget__element-icon--' }
              }}"
            >
              <ng-container *ngTemplateOutlet="limehomeMagnifierSvg" />
            </div>

            <div *ngIf="isMobile" class="widget__search-back-icon" (click)="showHideCityPicker()">
              <svg
                aria-hidden="true"
                focusable="false"
                data-prefix="fal"
                data-icon="arrow-left"
                class="svg-inline--fa fa-arrow-left"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 320 512"
              >
                <path
                  fill="#0A0A0A"
                  d="M234.8 36.25c3.438 3.141 5.156 7.438 5.156 11.75c0 3.891-1.406 7.781-4.25 10.86L53.77 256l181.1 197.1c6 6.5 5.625 16.64-.9062 22.61c-6.5 6-16.59 5.594-22.59-.8906l-192-208c-5.688-6.156-5.688-15.56 0-21.72l192-208C218.2 30.66 228.3 30.25 234.8 36.25z"
                />
              </svg>
            </div>

            <div
              class="widget__search-clear-icon"
              [ngClass]="{ 'widget__search-clear-icon--hidden': !searchModel }"
              (click)="clearSearchField(searchField)"
            >
              <i class="fa-regular fa-circle-xmark"></i>
            </div>
          </form>
        </div>
        <div class="widget__simplebar {{ classList | addClassList: { mainClass: 'widget__simplebar--' } }}">
          <div #simpleScrollBar class="widget__simplebar-inner" data-simplebar>
            <div *ngIf="emptyResults" class="alert widget__cities-alert">
              <ng-container *ngTemplateOutlet="triangleExclamationIcon" />
              {{ 'city-picker.empty-list-alert' | translate }}
            </div>
            <ul class="widget__cities-list" id="qa_cities-list">
              <li
                *ngFor="let item of filteredCities; let idx = index; trackBy: trackByFilteredCities"
                class="widget__cities-list-item"
              >
                <div>
                  <span *ngIf="idx === 0" class="widget__cities-list-country-label">
                    <ng-template
                      [ngTemplateOutlet]="countryFlag"
                      [ngTemplateOutletContext]="{
                        code: item.code
                      }"
                    >
                    </ng-template>
                    {{ item.country | localize }}
                  </span>
                  <span
                    *ngIf="
                      filteredCities[idx - 1] &&
                      filteredCities[idx].country[languages.en] !== filteredCities[idx - 1].country[languages.en]
                    "
                    class="widget__cities-list-country-label"
                  >
                    <ng-template
                      [ngTemplateOutlet]="countryFlag"
                      [ngTemplateOutletContext]="{
                        code: item.code
                      }"
                    >
                    </ng-template>
                    {{ item.country | localize }}
                  </span>
                  <p
                    class="widget__cities-list-city-label"
                    [ngClass]="{
                      'widget__cities-list-city-label--selected': city && item.id === city.id,
                      'widget__cities-list-city-label--active': idx === cityIndex
                    }"
                    [id]="'qa_city-' + item.city[languages.en]"
                    (click)="selectCity(item, idx)"
                  >
                    {{ item.city | localize }}
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #limehomeMagnifierSvg>
  <span
    class="widget__search-location-icon {{ classList | addClassList: { mainClass: 'widget__search-location-icon--' } }}"
  >
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_30908_19432)">
        <path
          d="M10.3125 4.9375C8.27344 4.9375 6.44531 6.02734 5.42578 7.75C4.40625 9.50781 4.40625 11.6523 5.42578 13.375C6.44531 15.1328 8.27344 16.1875 10.3125 16.1875C12.3164 16.1875 14.1445 15.1328 15.1641 13.375C16.1836 11.6523 16.1836 9.50781 15.1641 7.75C14.1445 6.02734 12.3164 4.9375 10.3125 4.9375ZM10.3125 17.875C6.26953 17.875 3 14.6055 3 10.5625C3 6.55469 6.26953 3.25 10.3125 3.25C14.3203 3.25 17.625 6.55469 17.625 10.5625C17.625 12.2852 17.0273 13.8672 16.043 15.1328L20.7188 19.8438C21.0703 20.1602 21.0703 20.6875 20.7188 21.0039C20.4023 21.3555 19.875 21.3555 19.5586 21.0039L14.8477 16.3281C13.582 17.3125 12 17.875 10.3125 17.875ZM13.125 9.4375H13.0898C13.0898 11.1602 11.4727 13.375 10.6992 14.3242C10.4883 14.5703 10.1016 14.5703 9.89062 14.3242C9.11719 13.375 7.5 11.1602 7.5 9.4375C7.5 7.89062 8.73047 6.625 10.3125 6.625C11.8594 6.625 13.125 7.89062 13.125 9.4375ZM9.1875 9.4375C9.1875 10.0703 9.67969 10.5625 10.3125 10.5625C10.9102 10.5625 11.4375 10.0703 11.4375 9.4375C11.4375 8.83984 10.9102 8.3125 10.3125 8.3125C9.67969 8.3125 9.1875 8.83984 9.1875 9.4375Z"
          fill="#0A0A0A"
        />
      </g>
      <defs>
        <clipPath id="clip0_30908_19432">
          <rect width="24" height="24" fill="white" transform="translate(0.333008)" />
        </clipPath>
      </defs>
    </svg>
  </span>
</ng-template>

<ng-template #countryFlag let-code="code">
  <span class="widget__cities-list-country-label-img-wrap">
    <img
      *ngIf="code"
      class="widget__cities-list-country-label-img"
      [src]="imgixHost + '/website/svg/country-flags/' + code + '.svg'"
      alt="{{ code }}"
    />
  </span>
</ng-template>

<ng-template #triangleExclamationIcon>
  <div class="widget__cities-alert-icon">
    <i class="fa-regular fa-triangle-exclamation"></i>
  </div>
</ng-template>
